<template>
  <div>
    <ValidationObserver
      ref="form"
      v-slot="{ invalid, validate, dirty }">
      <form
        @submit.prevent="validate().then(updateMe)"
        autocomplete="off">
        <div class="row">
          <div class="col-md-4">
            <ValidationProvider
              name="First Name"
              rules="required"
              v-slot="{ errors }">
              <base-input
                id="first_name"
                name="fname"
                autocomplete="off"
                type="text"
                label="First Name"
                placeholder="First Name"
                v-model.trim="user.first_name"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
          <div class="col-md-4">
            <ValidationProvider
              name="Last Name"
              rules="required"
              v-slot="{ errors }">
              <base-input
                id="last_name"
                name="lname"
                autocomplete="off"
                type="text"
                label="Last Name"
                placeholder="Last Name"
                v-model.trim="user.last_name"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
          <div class="col-md-4">
            <ValidationProvider
              name="Password"
              :rules="`min:${passwordMinLength}`"
              v-slot="{ errors }">
              <base-input
                id="password"
                unlock
                name="password"
                type="password"
                label="Password"
                placeholder="********"
                v-model.trim="user.password"
                autocomplete="new-password"
                :error="errors[0]" />
            </ValidationProvider>
          </div>
        </div>
        <base-button
          id="updateAccount"
          :disabled="invalid || !dirty"
          native-type="submit"
          type="primary"
          class="btn-fill">
          Update Account
        </base-button>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  name: 'EditAccountForm',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    me: {
      type: Object,
      required: true,
    },
    passwordMinLength: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      user: { ...this.me },
    };
  },
  methods: {
    updateMe() {
      this.$emit('updateMe', this.user);
      this.$refs.form.reset();
    },
  },
  watch: {
    me(update) {
      this.user = { ...update };
    },
  },
};
</script>
